import { useAuth } from '@/features/auth';
import { AppLayout } from './AppLayout';
import { PublicLayout } from './PublicLayout';
import { Loader2 } from 'lucide-react';

interface AdaptiveLayoutProps {
  children?: React.ReactNode;
}

/**
 * AdaptiveLayout - Switches between AppLayout and PublicLayout based on auth status
 *
 * - Authenticated users see full AppLayout with navigation
 * - Unauthenticated users see minimal PublicLayout with back button
 */
export function AdaptiveLayout({ children }: AdaptiveLayoutProps) {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-white/50" />
      </div>
    );
  }

  // Return appropriate layout based on auth state
  if (isAuthenticated) {
    return <AppLayout>{children}</AppLayout>;
  }

  return <PublicLayout>{children}</PublicLayout>;
}
